module.exports = __webpack_public_path__ + "img/preventive-frequency.060e4263.gif";